/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { SelfServiceConfigCheckinWithTokensResponse } from '../../models/self-service-config-checkin-with-tokens-response';

export interface GetSelfServiceConfigCheckin$Params {
  organizationSiteKey: KeyType;
}

export function getSelfServiceConfigCheckin(http: HttpClient, rootUrl: string, params: GetSelfServiceConfigCheckin$Params, context?: HttpContext): Observable<StrictHttpResponse<SelfServiceConfigCheckinWithTokensResponse>> {
  const rb = new RequestBuilder(rootUrl, getSelfServiceConfigCheckin.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelfServiceConfigCheckinWithTokensResponse>;
    })
  );
}

getSelfServiceConfigCheckin.PATH = '/administration/organization-sites/{organizationSiteKey}/self-checkin';
